import naja from 'naja';

// Lives in naja's options bag, which redirect follow-up requests reuse.
const GUARD_KEY = 'ehubSubmitGuard';
const LOCKED = 'locked';
const KEPT = 'kept';

const isSubmitter = (element) =>
  (element instanceof HTMLInputElement || element instanceof HTMLButtonElement) && element.form !== null;

const formOf = (element) => {
  if (isSubmitter(element)) {
    return element.form;
  }

  return element instanceof HTMLFormElement ? element : null;
};

// Not form.elements: a control named 'elements' shadows the collection.
const submitControlsOf = (form) =>
  [...form.querySelectorAll('button, input')].filter((control) => ['submit', 'image'].includes(control.type));

const release = (control) => {
  if (control.dataset.submitGuard === LOCKED) {
    control.disabled = false;
  }

  delete control.dataset.submitGuard;
};

naja.uiHandler.addEventListener('interaction', (event) => {
  const { element, options } = event.detail;
  const form = formOf(element);
  const controls = form === null ? [] : submitControlsOf(form);

  if (controls.length === 0) {
    return;
  }

  // Read by request-error-notice.js; naja itself never sets it.
  options.submitter = form === element ? controls[0] : element;
  options[GUARD_KEY] = controls;
});

naja.addEventListener('start', (event) => {
  event.detail.options[GUARD_KEY]?.forEach((control) => {
    // A soft redirect's follow-up request starts before the original completes; the first mark wins.
    if (control.dataset.submitGuard === undefined) {
      control.dataset.submitGuard = control.disabled ? KEPT : LOCKED;
    }

    control.disabled = true;
  });
});

naja.addEventListener('complete', (event) => {
  const { options, payload } = event.detail;

  if (payload?.redirect && options.forceRedirect !== false) {
    return;
  }

  options[GUARD_KEY]?.forEach(release);
});

// bfcache restores the page with the lock still applied.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    document.querySelectorAll('[data-submit-guard]').forEach(release);
  }
});
